var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCss(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 89,
    height: 100,
    viewBox: "0 0 89 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.02143 90.0036L0 0H88.1714L80.1393 89.9893L44.0321 100L8.02143 90.0036Z",
    fill: "#1572B6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M44.0857 92.3504L73.2643 84.2611L80.1285 7.36108H44.0857V92.3504Z",
    fill: "#33A9DC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M44.0857 39.9681H58.6928L59.7 28.6645H44.0857V17.6252H71.7643L71.5 20.586L68.7893 51.0074H44.0857V39.9681Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M44.1536 68.6359L44.1036 68.6501L31.8107 65.3287L31.025 56.5251H19.9429L21.4893 73.8573L44.1 80.1359L44.1536 80.1216V68.6359Z",
    fill: "#EBEBEB"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M57.7535 50.5391L56.425 65.3212L44.1143 68.6426V80.1284L66.7428 73.8569L66.9107 71.9926L68.8285 50.5391H57.7535Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M44.125 17.6252V28.6645H17.4607L17.2393 26.1824L16.7357 20.586L16.4714 17.6252H44.125ZM44.0857 39.9681V51.0074H31.9464L31.725 48.5252L31.225 42.9288L30.9607 39.9681H44.0857Z",
    fill: "#EBEBEB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCss);
export default __webpack_public_path__ + "static/media/CSS.340fe85bffec40d199f56cc4a54ed5da.svg";
export { ForwardRef as ReactComponent };